import { branch, compose, renderNothing } from 'recompose'
import { connect } from 'react-redux'

import {
  selectCurrentCELs,
  selectFirstLoanRate,
  selectFirstLoanAmount,
  selectFirstLoanTermYears,
  selectFirstLoanDate,
} from '../../../store/selectors/home/loans'
import { openLoans } from '../../../actions/homeowner'

const YourLoanSentenceContainer = compose(
  connect(
    state => ({
      loans: selectCurrentCELs(state),
      loanRate: selectFirstLoanRate(state),
      loanAmount: selectFirstLoanAmount(state),
      loanTerm: selectFirstLoanTermYears(state),
      loanDate: selectFirstLoanDate(state),
    }),
    dispatch => ({
      openLoans: () => dispatch(openLoans()),
    })
  ),
  branch(({ loans }) => !loans.length, renderNothing)
)

export default YourLoanSentenceContainer
